import { createSlice } from "@reduxjs/toolkit";
import { signupApi } from "./api";

const initialState = {
  response: {},
  loading: false,
  error: null,
};

const signupSlice = createSlice({
  name: "signupSlice",
  initialState,

  reducers: {
    clearSignupResponse: () => initialState,
  },

  extraReducers: (builder) => {
    builder.addCase(signupApi.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(signupApi.fulfilled, (state, action) => {
      state.response = action.payload;
      state.loading = false;
    });

    builder.addCase(signupApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { clearSignupResponse } = signupSlice.actions;

export default signupSlice.reducer;
